import React, { useEffect, useState } from "react"
import { CheckBox, DateBox, SelectBox, TagBox } from "devextreme-react";
import { baseRequest } from "../../fetch/basicThunk";
import { Button } from 'devextreme-react/button';
import { useDispatch } from "react-redux";
import { QUERY_GET_IMPORT_FILE_JOBS, QUERY_GET_IMPORT_FILE_TYPES, QUERY_IMPORT_FILE } from "../../fetch/constantQueries";
import { openModal } from "../../redux/modal/modalSlice";
import { Divider, IconButton, Typography } from "@material-ui/core";
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import { useRef } from "react";
import Table from "../table/Table";
import { Column } from "devextreme-react/data-grid";
import CustomPagination from "../table/CustomPagination";
import dayjs from "dayjs";
import SearchIcon from '@material-ui/icons/Search';


function FileManagement(){
    const [selectedMaster, setSelectedMaster] = useState();
    const [selectedFile, setSelectedFile] = useState()
    const dispatch = useDispatch();
    const inputRef = useRef();
    const [avaliableMasterValues, setAvaliableMasterValues] = useState()
    const [tablePageValues, setTablePageValues] = useState(
        {
            pageIndex: 1,
            totalRecords: 0,
            totalPages: 0,
            pageSize: 10,
            fileMasterTypes: [],
            startDate: dayjs().subtract(2, "month").toDate(),
            sortByField: "id",
            orderByAscending: false,
            showAll: false
        }
    )
    const [importJobs, setImportJobs] = useState([]);
    const [loadingImportJobs, setLoadingImportJobs] = useState("idle")

    const tableColumns = [
        <Column key={"fileimport-1"} width={"150px"} dataType={"datetime"} dataField={"startDate"} caption="Data" />,
        <Column key={"fileimport-2"} width={"150px"} dataField={"importType"} caption="Tipo" />,
        <Column key={"fileimport-3"} dataField={"fileName"} caption="Nome do arquivo" />,
        <Column key={"fileimport-4"} width={"100px"} dataField={"importState"} caption="Status" />,
        <Column key={"fileimport-5"} dataField={"errorMessage"} caption="Mensagem" />,
        <Column key={"fileimport-6"} width={"150px"} dataField={"isCRMImport"} caption="Tipo de importação" calculateSortValue={"isCRMImport"} calculateCellValue={(rowData)=> rowData.isCRMImport? "Manual" : "Automática"}/>
    ]

    useEffect(()=>{
        baseRequest(null, dispatch, QUERY_GET_IMPORT_FILE_TYPES , "GET").then(
            (data)=> setAvaliableMasterValues(data)
        )
        getImportJobs(tablePageValues)

    },[])


    function getImportJobs(values){
        setLoadingImportJobs("loading")
        baseRequest({query: `?pageNum=${values.pageSize}&pageIndex=${values.pageIndex-1}&startDate=${dayjs(values.startDate).format("YYYY-MM-DD")}&fileMasterTypes=${values.fileMasterTypes.join()}&orderByAscending=${values.orderByAscending}&orderByField=${values.sortByField}&showAll=${values.showAll}`}, dispatch, QUERY_GET_IMPORT_FILE_JOBS, "GET" ).then(
            (data)=>  {
                setImportJobs(data.elements);
                setTablePageValues(prevState=>({...prevState, totalRecords: data.totalRecords, totalPages: data.totalPages}))
                setLoadingImportJobs("succeeded");
            }
        ).catch(
            (error)=> {
                setLoadingImportJobs("failed");
                dispatch(openModal({type:"warning", message: "Não foi possível carregar o histórico de importações."}))
            }
        )
    }


    function handleSubmit()
    {
        if(!validateSubmitData())
                return;

        let submitData = new FormData();
        submitData.append(`file`, selectedFile)

        baseRequest({body: submitData, param: selectedMaster, excludeContentType: true}, dispatch, QUERY_IMPORT_FILE, "POST").then(
            (data)=> {
                    handleRefresh()
                    dispatch(openModal({type: "success", message: "Importação finalizada com sucesso."}));
            },
            (error)=>{handleRefresh()}).catch(
                ()=> handleRefresh()
            )

        setSelectedFile(null);
        setSelectedMaster(null);
        inputRef.current.files = null;
        inputRef.current.value = [];
    }

    function handleLoadFile(e){

        if(e.target.files.length > 0){
            const file = e.target.files[0];
            const isExcelFile = file.name.endsWith(".xlsx") || file.name.endsWith(".xls")
            if(!isExcelFile){
                e.target.files = null
                dispatch(openModal({type: "warning", message: "O formato do arquivo não é válido."}))
                return
            }
            setSelectedFile(e.target.files[0])
        } else {
            setSelectedFile(null)
        }

    }

    function validateSubmitData()
    {
        if(!selectedFile){
                dispatch(openModal({type: "warning", message: "Nenhum arquivo foi carregado"}))
                return false;
            }
        if(!selectedMaster){
                dispatch(openModal({type: "warning", message: "Por favor, preencha o campo Tipo"}))
                return false;
        }
        return true;
    }

    function handlePageSizeChange(value){
        getImportJobs({...tablePageValues, pageSize: value})
        setTablePageValues(prevState=>({...prevState, pageSize: value}))
    }

    const handlePageIndexChange = (event, value) => {
        getImportJobs({...tablePageValues, pageIndex: value})
        setTablePageValues(prevState=>({...prevState, pageIndex: value}))
    };

    function handleRefresh(){
        getImportJobs(tablePageValues)
    }

    function setTypeMasterFilters(value){
        const masterTypes = value.length > 0 ? value : [];
        setTablePageValues(prevState=>({...prevState, fileMasterTypes: masterTypes}))

    }

    function handleCellClick (e) {
        if (e.rowType == "header" && (e.column.type !== "selection" && e.column.type !== "buttons")) {
            let columna = e.column.dataField;
            let sortOrder = e.column.sortOrder;
            if (sortOrder == undefined || sortOrder == "undefined") {
                e.column.sortOrder = 'asc';
            }
            else if (sortOrder == 'desc') {
                e.column.sortOrder = 'asc';
            }
    
            else if (sortOrder == 'asc') {
                e.column.sortOrder = 'desc';
            }
            let orden = e.column.sortOrder == 'asc' ? true : false;
            getImportJobs({...tablePageValues, sortByField: columna, orderByAscending: orden})
            setTablePageValues(prevState=>({...prevState, sortByField: columna, orderByAscending: orden}))
        }   
    }

    return(
        <div style={{width: "90%", margin: "auto"}}>
                <div style={{margin: "10px"}}>
                    <div style={{display: "flex", justifyContent: "center", margin: "12px 0"}}><Typography>Importar arquivos</Typography></div>
                    <div className="import-wrapper">
                    <SelectBox
                        height={39}
                        name = "masterName"
                        noDataText="Carregando tipos"
                        dataSource = { avaliableMasterValues }
                        value = { selectedMaster}
                        displayExpr = { "keyword" }
                        valueExpr = { "keyword" }
                        onValueChanged = { (e) => setSelectedMaster(e.value) }
                        placeholder="Tipo"
                    />
                    <span>   
                    <label to={"fileUpload"} className="dx-button dx-button-normal dx-button-mode-contained dx-widget dx-button-has-icon dx-button-has-text file-input-button">
                        <input ref={inputRef} accept=".xls,.xlsx" onChange={handleLoadFile} style={{display: "none"}} id="fileUpload" type={"file"}/>
                        <div className="dx-button-content" style={{display: "flex", alignItems: "center", columnGap: "4px"}}>
                            <NoteAddIcon/> Selecionar arquivo
                        </div>
                    </label>
                    </span>
                    <span style={{fontSize: "12px"}}>{selectedFile && selectedFile.name}</span>
                    <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Button  icon="upload" text={"Carregar arquivo"} disabled={(!selectedFile || !selectedMaster)} height={39} onClick={handleSubmit}/>
                    </div>
                    </div>
                    
                        <ol style={{fontSize:"12px", padding: 0, margin: 14}}>
                            <li>Selecione o tipo e arquivo a ser importado</li>
                            <li>Clique em "Carregar arquivo"</li>
                            <li>Quando o arquivo for carregado, aparecerá o resultado no histórico abaixo</li>
                        </ol>

                </div>
                    <div style={{marginTop: "20px", marginBottom: "20px", }}>
                        <Divider orientation="horizontal" style={{width: "100%"}}/>
                    </div>
                    <div style={{}}>
                        <div style={{display: "flex", justifyContent: "center", margin: "12px 0"}}><Typography>Histórico</Typography></div>
                        <div style={{display: "flex", alignItems: "center", columnGap: "12px", margin: "0 10px"}}>
                            <DateBox 
                                height={39}
                                placeholder="Fecha desde"
                                value={tablePageValues.startDate}
                                onValueChanged={(e)=> setTablePageValues(prevState=>({...prevState, startDate: e.value}))}
                            />
                            <TagBox
                                width={250}
                                height={39}
                                name = "masterFilter"
                                noDataText="Carregando tipos"
                                dataSource = {avaliableMasterValues}
                                defaultValue = {tablePageValues.fileMasterTypes}
                                displayExpr = { "keyword" }
                                valueExpr = { "id" }
                                onValueChanged = { (e) => setTypeMasterFilters(e.value) }
                                placeholder="Tipo"
                            />
                            <div style={{display: "flex", alignItems: "center", columnGap: "6px"}}>
                                <CheckBox 
                                     name = "showAll"
                                     value = { tablePageValues.showAll }
                                     onValueChanged = { (e) => setTablePageValues(prevState=>({...prevState, showAll:e.value})) }
                                 >
                                 </CheckBox>
                                <div style={{fontSize: "12px"}}>
                                     Exibir importações automáticas
                                </div>
                            </div>
                            <div style={{width: "40px"}}><IconButton onClick={()=>handleRefresh()} size="small" title="Procurar"><SearchIcon htmlColor="#3B5158"/></IconButton></div>

                        </div>

                        <Table
                            datasource={importJobs}
                            loading={loadingImportJobs} 
                            columnasTabla={tableColumns}   
                            handleCellClick={handleCellClick}
                        />
                        <CustomPagination numElements={[10, 50, 100]} refreshPage={handleRefresh} style={{position: "absolute"}} loading={loadingImportJobs} count={tablePageValues.totalRecords} pageSize={tablePageValues.pageSize} pageIndex={tablePageValues.pageIndex} totalPages={tablePageValues.totalPages} handlePageSizeChange={handlePageSizeChange} handlePageIndexChange={handlePageIndexChange} />
                    </div>

            </div>

    )
}

export {FileManagement}